const BaseUrlImage = "https://www.kikaiins.com";
export default BaseUrlImage;
